import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getCustomerContactsByCustomerId(customerId) {
            var meta = { clientApiMethod: 'getCustomerContactsByCustomerId', input: { customerId: customerId } }
            var response = await client().get(store.state.apiRouteRoot + "CustomerPerson/Customer/" + customerId + "/AllContacts", { meta: meta })
            response?.data.map((element) => {
                element.MetaString = "" +
                    element.Id + " " +
                    element.Name + " " +
                    element.DisplayName + " " +
                    element.Title + " " +
                    element.Mobile + " " +
                    element.Email;
            })
            return response?.data;
        },
        async getCustomerContactById(contactId) {
            var meta = { clientApiMethod: 'getCustomerContactById', input: { contactId: contactId } }
            var response = await client().get(store.state.apiRouteRoot + "CustomerPerson/Customer/contact/" + contactId, { meta: meta })
            return response?.data;
        },
        async createCustomerContact(newContact) {
            var meta = {
                clientApiMethod: 'createCustomerContact',
                input: { newContact },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.contact.contact") })
            }
            var response = await client().post(store.state.apiRouteRoot + "CustomerPerson/customer/" + newContact.CustomerId + "/contact/add", newContact, { meta: meta })
            return response?.data;
        },
        async changeCustomerContactById(contact) {
            var meta = {
                clientApiMethod: 'changeCustomerContactById',
                input: { contact },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.contact.contact") })
            }
            var response = await client().put(store.state.apiRouteRoot + "CustomerPerson/customer/" + contact.CustomerId + "/contact/" + contact.Id + "/update", contact, { meta: meta })
            return response?.data;
        },
        async swapCustomerContact(jobId, contactId) {
            var meta = {
                clientApiMethod: 'swapCustomerContact',
                input: { jobId: jobId, contactId: contactId },
                successText: i18n.t("servicesystem.responses.swapped_object", { okey: i18n.t("servicesystem.common_objects.contact.contact") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "job/" + jobId + "/swapcontact/" + contactId, null, { meta: meta })
            return response?.data;
        },
    }
}